// noinspection JSVoidFunctionReturnValueUsed

const campaignIndex = ((jQuery) => {
  'use strict';

  let oTable;
  let $campaignTreeTable = jQuery('#campaigns_tree_table');
  if ($campaignTreeTable.length === 0) {
    return;
  }

  const initTreeTable = () => {
    oTable = $campaignTreeTable.treeTable({
      data: window.campaignsListData,
      info: false,
      collapsed: true,
      autoWidth: false,
      paging: false,
      pageLength: 50,
      stateSave: true,
      language: {url: '/vendor/datatables/' + AppLocale + '.json'},
      columns: [
        {data: 'id'},
        {data: 'link'},
        {data: 'brand'},
        {data: 'category'},
        {data: 'type'},
        {data: 'audit'},
        {data: 'budget'},
        {data: 'spent'},
        {data: 'deliver'},
        {data: 'dates'},
        {data: 'status'},
        {data: 'actions'},
      ],
      sDom: 'lrtip',
      columnDefs: [
        {targets: 'no-sort', orderable: false},
        {"className": "dt-center", "targets": "center"},
      ],
      initComplete: function () {
        $campaignTreeTable.removeClass('d-none');
        jQuery('#pagination').removeClass('d-none');
      }
    });
  }

  /**
   * Disable given toggles.
   */
  function disableToggles() {

    /**
     * Line item and Insertion Order toggles.
     *
     * @type {NodeListOf<Element>}
     */
    let toggles = document.querySelectorAll('.toggle-io-status, .toggle-li-status');

    for (let toggle of toggles) {
      toggle.disabled = true;
    }
  }

  /**
   * Enable given toggles.
   */
  function enableToggles() {

    /**
     * Line item and Insertion Order toggles.
     *
     * @type {NodeListOf<Element>}
     */
    let toggles = document.querySelectorAll('.toggle-io-status, .toggle-li-status');

    for (let toggle of toggles) {
      toggle.disabled = false;
    }
  }

  const toggleIOStatus = (el, e) => {
    let id = el.dataset.id;

    let format = el.dataset.format;

    if (!id) {
      return;
    }

    let token = el.dataset.token;
    let url = el.dataset.action
    let msg = {
      error: el.dataset.error,
      success: el.dataset.success
    }

    if (format === 'search') {

      if (el.checked) {

        updateInsertionOrder(url, id, token, msg);

      } else {

        e.preventDefault();

        document.querySelector('#toggle_search_io_modal').dataset.id = id;

        document.querySelector('#toggle_search_io_modal').dataset.msgError = msg.error;

        document.querySelector('#toggle_search_io_modal').dataset.msgSuccess = msg.success;

        $('#toggle_search_io_modal').modal('show');

      }

    } else {

      updateInsertionOrder(url, id, token, msg);

    }

  }

  const updateInsertionOrder = (url, id, token, msg) => {

    disableToggles();

    jQuery.ajax({
      headers: {
        'X-CSRF-TOKEN': token,
      },
      url: url,
      error: () => {

        toastr.error(msg.error);

        enableToggles();

      },
      success: (data) => {

        let insertionOrder = JSON.parse(data);

        /**
         * Disable child Line Items if IO is searchandizing and has been disabled.
         */
        if (insertionOrder.status === false && insertionOrder.format === 'search') {

          let lineItemToggles = document.querySelectorAll(`.toggle-li-status[data-io-id="${id}"]:checked`);

          for (let toggle of lineItemToggles) {
            toggle.checked = false;
          }

        }

        enableToggles();

        toastr.success(msg.success);

      },
      type: 'PATCH'
    });
  }

  /**
   * Update Insertion Order from modal.
   */
  const updateInsertionOrderFromModal = () => {

    let modal = document.querySelector('#toggle_search_io_modal');

    let id = modal.dataset.id;

    let messageError = modal.dataset.msgError;

    let messageSuccess = modal.dataset.msgSuccess;

    disableToggles();

    jQuery.ajax({
      headers: {
        'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content
      },
      url: `/activation/insertion-orders/${id}/toggle-status`,
      error: function () {

        toastr.error(
          messageError !== ''
            ? messageError
            : 'Une erreur est survenue. Veuillez rééssayer.'
        );

        enableToggles();

      },
      success: function (data) {

        let insertionOrder = JSON.parse(data);

        /**
         * Disable child Line Items if IO is searchandizing and has been disabled.
         */
        if (insertionOrder.status === false && insertionOrder.format === 'search') {

          let lineItemToggles = document.querySelectorAll(`.toggle-li-status[data-io-id="${insertionOrder.id}"]:checked`);

          for (let toggle of lineItemToggles) {
            toggle.checked = false;
          }

          document.querySelector(`.toggle-io-status[data-id="${insertionOrder.id}"]`).checked = false;

        }

        enableToggles();

        toastr.success(messageSuccess);

      },
      type: 'PATCH'
    });

  }

  const toggleLIStatus = (el) => {
    let id = el.dataset.id;

    if (!id) {
      return;
    }

    let token = el.dataset.token;
    let url = el.dataset.action
    let msg = {
      error: el.dataset.error,
      success: el.dataset.success
    }

    disableToggles();

    jQuery.ajax({
      headers: {
        'X-CSRF-TOKEN': token,
      },
      url: url,
      error: () => {

        toastr.error(msg.error);

        enableToggles();

      },
      success: (data) => {

        toastr.success(msg.success);

        enableToggles();

      },
      type: 'PATCH'
    });
  }

  const handleDeleteModal = () => {
    let element = null;
    jQuery('.delete-campaign').on('click', (e) => {
      jQuery('#delete-campaign-modal').modal();
      element = e.target;
    });
    jQuery('#confirm-delete-campaign').on('click', () => {
      jQuery(element).parents('form').submit();
    });
  };

  const handleSearchAndPagination = () => {
    let $form = jQuery('#form-list-campaigns');

    $form.one('submit', event => {
      event.preventDefault();
      jQuery('#loading').removeClass('d-none');
      jQuery(event.currentTarget).submit();
    });

    jQuery('#btn-filter').click(() => {
      jQuery('#filtered').val(true);
      $form.submit();
    });

    jQuery('#table_length_selector').on('change', event => {
      jQuery('#table_length_input').val(jQuery(event.currentTarget).val());
      $form.submit();
    });

    jQuery('.page-link').one('click', event => {
      event.preventDefault();
      jQuery('#loading').removeClass('d-none');
      window.location.href = jQuery(event.currentTarget).attr('href');
    });
  };

  jQuery.fn.extend({
    toggleText: (a, b) => {
      return this.text(this.text() === b ? a : b);
    }
  });

  jQuery(() => {
    initTreeTable();
    handleDeleteModal();
    handleSearchAndPagination();
  });

  window.toggleIOStatus = toggleIOStatus;
  window.toggleLIStatus = toggleLIStatus;
  window.updateInsertionOrderFromModal = updateInsertionOrderFromModal;

})(jQuery);
